import { useEffect, useState } from "react";
import { useLang } from "../lang";

const items = [
  { id: "hero", pt: "oie", en: "hi" },
  { id: "about", pt: "sobre", en: "about" },
  { id: "skills", pt: "experiência", en: "experience" },
  { id: "portfolio", pt: "trabalhos", en: "work" },
  { id: "substack", pt: "substack", en: "substack" },
  { id: "contact", pt: "contato", en: "contact" },
];

export default function Nav({ onNavigate }) {
  const [active, setActive] = useState("hero");
  const { lang, setLang } = useLang();
  useEffect(() => {
    const h = () => {
      const y = window.scrollY + window.innerHeight / 3;
      let cur = "hero";
      for (const it of items) {
        const el = document.getElementById(it.id);
        if (el && el.offsetTop <= y) cur = it.id;
      }
      setActive(cur);
    };
    window.addEventListener("scroll", h, { passive: true });
    h();
    return () => window.removeEventListener("scroll", h);
  }, []);
  return (
    <nav className="nav-bar" data-testid="main-nav">
      <span className="brand">gabriela ferraz ☺</span>
      <div className="nav-links">
        {items.map((it) => (
          <button
            key={it.id}
            data-testid={`nav-${it.id}-link`}
            className={active === it.id ? "active" : ""}
            onClick={() => onNavigate(it.id)}
          >
            {it[lang] || it.pt}
          </button>
        ))}
        <div
          className="lang-toggle"
          role="group"
          aria-label="language toggle"
          data-testid="lang-toggle"
        >
          <button
            onClick={() => setLang("pt")}
            data-testid="lang-pt"
            aria-pressed={lang === "pt"}
            aria-label="Português"
            className={lang === "pt" ? "on" : ""}
            title="Português"
          >
            <span aria-hidden="true">🇧🇷</span>
          </button>
          <span className="lang-sep">·</span>
          <button
            onClick={() => setLang("en")}
            data-testid="lang-en"
            aria-pressed={lang === "en"}
            aria-label="English"
            className={lang === "en" ? "on" : ""}
            title="English"
          >
            <span aria-hidden="true">🇺🇸</span>
          </button>
        </div>
      </div>
    </nav>
  );
}
